import { deepPurple } from '@mui/material/colors';
import { Box, Card, Grid, Stack, useTheme, Typography } from '@mui/material';

import { useResponsive } from 'src/hooks/use-responsive';

export const DetailTaskManageFunction = () => {
  const theme = useTheme();
  const deepPurpleColor = deepPurple.A200;

  const smDown = useResponsive('down', 'sm');
  const padding = () => {
    if (smDown) {
      return 2;
    }
    return 3;
  };
  return (
    <Stack mb={smDown ? 5 : 10}>
      <Stack my={5} spacing={2} alignItems="center">
        <Typography
          fontFamily='"Shantell Sans Light", sans-serif'
          sx={{ color: deepPurpleColor }}
          fontSize={18}
          align="center"
          fontWeight="medium"
        >
          Phần mềm quản lý trung tâm thế hệ mới
        </Typography>
        <Typography variant="h2" align="center">
          Quản lý công việc hiệu quả
        </Typography>
        <Stack>
          <Typography variant="body1" align="center" maxWidth={808}>
            Phân công nhiệm vụ, theo dõi tiến độ và đánh giá hiệu suất nhân sự theo từng công việc.
            Quản lý mọi hoạt động vận hành của trung tâm hiệu quả hơn với phần mềm quản lý trung tâm
            CenterUp.
          </Typography>
        </Stack>
      </Stack>
      <Stack alignSelf="center" maxWidth={1150}>
        <Grid container justifySelf="center" spacing={4} alignItems="stretch">
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
                position: 'relative',
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack zIndex={2} px={padding} pt={padding}>
                  <Typography variant="h5">Quản lý công việc trực quan</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Theo dõi và xử lý công việc dễ dàng với giao diện danh sách công việc trực quan
                    và bộ lọc linh hoạt
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="employee-detail"
                    src="/assets/sub-pages/manage/task/list-task.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding}>
                  <Typography variant="h5">Tùy biến trường thông tin</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Thêm các trường dữ liệu riêng phù hợp với cách làm việc của trung tâm – dễ lọc,
                    dễ quản lý.
                  </Typography>
                </Stack>{' '}
                <Stack>
                  <Box
                    alignSelf="flex-end"
                    alt="class-dashboard"
                    component="img"
                    width="100%"
                    src="/assets/sub-pages/manage/task/setting.png"
                    zIndex={2}
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding}>
                  <Typography variant="h5">Ghi chú, trao đổi, đính kèm tài liệu</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Ghi chú, bình luận, đính kèm file ngay trong từng nhiệm vụ – thay thế việc hỏi
                    han trên Zalo hay gửi mail thủ công.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="class-task"
                    src="/assets/sub-pages/manage/task/file.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding} width={1}>
                  <Typography variant="h5">Tự động nhắc việc & thông báo hạn deadline</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Tự động thông báo đến hạn, quá hạn và cập nhật trạng thái giúp nhân viên không
                    bỏ lỡ nhiệm vụ nào.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="class-schedule"
                    src="/assets/sub-pages/manage/task/notification.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding} width={1}>
                  <Typography variant="h5">Báo cáo hiệu suất minh bạch</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Hiển thị rõ tiến độ, số lượng và tỷ lệ hoàn thành công việc theo từng người và
                    từng bộ phận – dễ dàng đánh giá hiệu quả làm việc.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="class-schedule"
                    src="/assets/sub-pages/manage/task/report.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding} width={1}>
                  <Typography variant="h5">Lịch làm việc đồng bộ</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Lịch hiển thị đầy đủ ca dạy, lớp học, người phụ trách, học viên, đồng bộ toàn
                    Trung tâm và cảnh báo tự động nếu chưa điểm danh hoặc chưa chấm điểm
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="class-schedule"
                    src="/assets/sub-pages/manage/task/sync.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Stack>
    </Stack>
  );
};
